module.exports = __webpack_public_path__ + "static/Onsite-Clinics-Raise-Benefits-Package-min-200287469434fd380b4aa866171a3257.png";